import ActionTypes from "../constants/action-types";
import store from "../reducers/reducer";

export const setShowChatGallery = (payload) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_SHOW_CHAT_GALLERY,
        payload
    });

    if (payload === "false") {
        dispatch(setChatGalleryMessages([]));
    }
};

export const setShowChatGalleryIsBusy = (payload) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_GET_CHAT_GALLERY_IS_BUSY,
        payload
    });
};

export const setChatGalleryFilter = (payload) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_CHAT_GALLERY_FILTER,
        payload
    });
};

export const setChatGalleryHasMore = (payload) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_CHAT_GALLERY_HAS_MORE,
        payload
    });
}

export const setChatGalleryMessages = (payload) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_CHAT_GALLERY_MESSAGES,
        payload,
    });
}

export const setChatGalleryActiveMessage = (payload) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_CHAT_GALLERY_ACTIVE_MESSAGE,
        payload,
    })
}

export const setChatGallerySource = (payload) => (dispatch) => {
    dispatch({
        type: ActionTypes.SET_CHAT_GALLERY_SOURCE,
        payload,
    })
}

export const getChatGallery = (args) => async (dispatch) => {

    const state = store.getState().chatGallery;
    const reset = args.reset ?? false;

    if (state.isLoading || !state.hasMore) {
        return;
    }

    dispatch({
        type: ActionTypes.SET_GET_CHAT_GALLERY_IS_BUSY,
        payload: true
    });

    await axios.get('/api/get-chat-gallery', {
        params: args
    })
        .then((response)=> {

            if (state.messages.length === 0 || reset) {

                dispatch({
                    type: ActionTypes.SET_CHAT_GALLERY_MESSAGES,
                    payload: response.data.messages,
                });

            } else {
                let tmp = [...state.messages];
                tmp = [...tmp, ...response.data.messages];

                dispatch({
                    type: ActionTypes.SET_CHAT_GALLERY_MESSAGES,
                    payload: tmp,
                });
            }

            if (response.data.messages.length < args.per_page) {
                dispatch({
                    type: ActionTypes.SET_CHAT_GALLERY_HAS_MORE,
                    payload: false,
                });
            }

            dispatch({
                type: ActionTypes.SET_GET_CHAT_GALLERY_IS_BUSY,
                payload: false
            });
        })
        .catch((error)=> {
            console.log('chat gallery error', error);
            dispatch({
                type: ActionTypes.SET_GET_CHAT_GALLERY_IS_BUSY,
                payload: false,
            });
        });
};
